function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import noop from 'lodash.noop';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import React from 'react';
import Button from './Button';
import ConfirmationButton from './ConfirmationButton';
import Col from './Col';
import Icon from './Icon';
import Row from './Row';
import Tooltip from './Tooltip';
var count = 0;

function getID() {
  return "hmf-".concat(count += 1); // eslint-disable-line no-return-assign
}

var HasManyFieldsRow = /*#__PURE__*/function (_React$Component) {
  _inherits(HasManyFieldsRow, _React$Component);

  var _super = _createSuper(HasManyFieldsRow);

  function HasManyFieldsRow() {
    _classCallCheck(this, HasManyFieldsRow);

    return _super.apply(this, arguments);
  }

  _createClass(HasManyFieldsRow, [{
    key: "UNSAFE_componentWillMount",
    //eslint-disable-next-line camelcase
    value: function UNSAFE_componentWillMount() {
      this.id = getID();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disabledReason = _this$props.disabledReason,
          onDelete = _this$props.onDelete,
          disabled = _this$props.disabled,
          disabledReasonPlacement = _this$props.disabledReasonPlacement,
          deletable = _this$props.deletable,
          deleteProps = _this$props.deleteProps;
      var classNames = classnames('mb-4', className); // The `disabled ? <Button> : <ConfirmationButton>` code works around Tooltips not show on `disabled` elements:

      var tooltip = disabled && disabledReason ? /*#__PURE__*/React.createElement(Tooltip, {
        placement: disabledReasonPlacement,
        target: this.id
      }, disabledReason) : null;
      var button = disabled ? /*#__PURE__*/React.createElement(Button, {
        id: this.id,
        color: "danger",
        onClick: function onClick(e) {
          return e.preventDefault();
        },
        outline: true,
        className: "p-2 disabled"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "times-circle-o",
        size: "lg"
      })) : /*#__PURE__*/React.createElement(ConfirmationButton, _extends({
        color: "danger",
        confirmation: "Delete",
        "aria-label": "Delete",
        outline: true,
        onClick: onDelete,
        className: "p-2"
      }, deleteProps), /*#__PURE__*/React.createElement(Icon, {
        name: "times-circle-o",
        size: "lg"
      }));
      return /*#__PURE__*/React.createElement(Row, {
        className: classNames,
        noGutters: true
      }, /*#__PURE__*/React.createElement(Col, null, children), deletable && /*#__PURE__*/React.createElement(Col, {
        xs: "auto",
        className: "js-delete-col pl-3 d-flex"
      }, button, tooltip));
    }
  }]);

  return HasManyFieldsRow;
}(React.Component);

HasManyFieldsRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.node,
  disabledReasonPlacement: PropTypes.string,
  onDelete: PropTypes.func,
  deletable: PropTypes.bool,
  deleteProps: PropTypes.object
};
HasManyFieldsRow.defaultProps = {
  disabledReasonPlacement: 'top',
  disabled: false,
  onDelete: noop,
  deletable: true
};
HasManyFieldsRow.displayName = "HasManyFieldsRow";
export { HasManyFieldsRow as default };
//# sourceMappingURL=HasManyFieldsRow.js.map